import { useLocation, useNavigate } from 'react-router-dom';

interface LanguageSwitcherProps {
  showWhite?: boolean;
}

const pathMap: Record<string, string> = {
  '/en': '/ja',
  '/ja': '/en',
  '/en/locations': '/ja/locations',
  '/ja/locations': '/en/locations',
  '/en/advertise': '/ja/advertise',
  '/ja/advertise': '/en/advertise',
  '/en/simulator': '/ja/simulator',
  '/ja/simulator': '/en/simulator',
  '/en/partnership': '/ja/partnership',
  '/ja/partnership': '/en/partnership',
  '/en/privacy': '/ja/privacy',
  '/ja/privacy': '/en/privacy',
  '/en/terms': '/ja/terms',
  '/ja/terms': '/en/terms',
};

export default function LanguageSwitcher({ showWhite = false }: LanguageSwitcherProps) {
  const location = useLocation();
  const navigate = useNavigate();
  const isEN = location.pathname.startsWith('/en');
  const basePath = location.pathname.replace(/#.*$/, '');
  const hash = location.hash || '';

  const handleLanguageSwitch = (e: React.MouseEvent) => {
    e.preventDefault();

    // Blog article pages
    const enBlogMatch = basePath.match(/^\/en\/blog\/(.+)$/);
    const jaBlogMatch = basePath.match(/^\/ja\/blog\/(.+)$/);

    if (enBlogMatch) {
      navigate(`/ja/blog/${enBlogMatch[1]}`);
      return;
    }

    if (jaBlogMatch) {
      navigate(`/en/blog/${jaBlogMatch[1]}`);
      return;
    }

    // Use pathMap for all other pages
    const targetPath = (pathMap[basePath] ?? (isEN ? '/ja' : '/en')) + hash;
    navigate(targetPath);
  };

  const activeClass = showWhite ? 'text-gray-900 font-bold' : 'text-white font-bold';
  const inactiveClass = showWhite ? 'text-gray-400 hover:text-gray-600' : 'text-white/50 hover:text-white/80';

  return (
    <div className="flex items-center gap-1 text-xs cursor-pointer select-none">
      {isEN ? (
        <>
          <a onClick={handleLanguageSwitch} className={`${inactiveClass} transition-colors cursor-pointer`}>JP</a>
          <span className={showWhite ? 'text-gray-300' : 'text-white/30'}>|</span>
          <span className={activeClass}>EN</span>
        </>
      ) : (
        <>
          <span className={activeClass}>JP</span>
          <span className={showWhite ? 'text-gray-300' : 'text-white/30'}>|</span>
          <a onClick={handleLanguageSwitch} className={`${inactiveClass} transition-colors cursor-pointer`}>EN</a>
        </>
      )}
    </div>
  );
}